<template>
  <div class="content-wrap">
        <div class="main">
            <div class="container-fluid">
                <div class="main-content" v-if="openNewItem">
                    <addItem :section="menuSections" @add-item="addItem(...arguments)" @cancel-item="cancelItem()"></addItem>
                </div>
                <div class="main-content" v-else>
                    <br>
                    <br>
                    <button type="button" class="btn btn-primary btn-rounded  m-l-5" @click="openNewItem = true">Agregar artículo</button>
                </div>

                <div class="main-content">
                        <div class="row" v-for="section in menuSections" v-bind:key="section">
                            <h1>{{ section.toUpperCase() }}</h1>
                            <articleMenu v-for="(nu, index) in menuItems[section]" :key="nu" :item="nu" :section="section" :index="index" @delete-item="deleteItem(...arguments)"></articleMenu>
                        </div>
                </div><!-- /# main content -->
            </div><!-- /# container-fluid -->
        </div><!-- /# main -->
    </div>
</template>
<script>
import articleMenu from "@/components/MenuArticleComponent.vue";
import firebase from 'firebase'
import addItem from "@/components/AddItemComponent.vue"

export default {
    components:{
        articleMenu,
        addItem
    },
    data(){
        return{
            menuSections: [],
            menuItems: [],
            changeComp: true,
            openNewItem: false
        }
    },
    mounted(){
        this.retrieveMenu()
    },
    methods:{
        retrieveMenu: function(){
            const db = firebase.firestore()

            db.collection("restaurants").doc('1001').get().then((doc) => {
                if (doc.exists) {
                    this.menuSections = Object.keys(doc.data().menu)
                    this.menuItems = doc.data().menu
                }
            })
        },
        deleteItem: function(event){

            const db = firebase.firestore()
            var restRef = db.collection('restaurants').doc('1001');

            restRef.update({
                ['menu.' + event[0] + '.' + event[1]]: firebase.firestore.FieldValue.delete()

            }).then(() => this.menuItems[event[0]][event[1]] = undefined)
        },
        addItem: function(event) {
            const db = firebase.firestore();
            var restRef = db.collection('restaurants').doc('1001');

            var itemKeys = Object.keys(this.menuItems[event[0]]);
            var nextID = parseInt(itemKeys[itemKeys.length-1]) + 1;

            let section = event[0];
            let title = event[1];
            let description = event[2];
            let imageChosen = event[3];
            let cost = event[4];

            var storageRef = firebase.storage().ref();
            let newImageRef = storageRef.child(section).child(imageChosen.name);

            var uploadTask = newImageRef.put(imageChosen);
            uploadTask.on(
                'state_changed',
                (snapshot) => { /*observe upload progress*/ },
                (error) => { console.log("error uploading"); },
                () => {
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    console.log('File available at ', downloadURL);
                    restRef.update({
                        ['menu.' + section + '.' + nextID ]: {
                            title: title,
                            description: description,
                            img: downloadURL,
                            cost: parseInt(cost),
                            status: 1,
                            id: nextID
                        }

                    }).then(() => {
                        this.retrieveMenu();
                        this.openNewItem = false;
                    });
                });
                }
            );
        },
        cancelItem: function(){
            this.openNewItem = false
        }
    }
};
</script>
